import { cn } from '@/utils/cn';
import type { ReactNode } from 'react';

interface ChartCardProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

export function ChartCard({ title, description, children, className }: ChartCardProps) {
  return (
    <section className={cn('card p-5', className)}>
      <div className="mb-4">
        <h3 className="section-title">{title}</h3>
        {description && <p className="section-description mt-0.5">{description}</p>}
      </div>
      {children}
    </section>
  );
}
